export default "__VITE_ASSET__BhVhPeA4__"